<template>
  <div
    v-if="$canAndRulesPass(user, $permissions.USER.ORGSTRUCT_VIEW)"
    v-loading="loading"
    style="position: relative"
  >

    <orgstruct-tree
      ref="orgstructTree"
      :datasource="ds"
      pan
      zoom
      children-field="subordinates"
      position-field="position"
      fio-field="full_name"
      :show-cards="showCards"
      :toggle-show-functional-chief="toggleShowFunctionalChief"
      :current-user-id="currentUserId"
      @load-parent="loadParent"
      @load-child="loadChild"
    >
    </orgstruct-tree>

    <div class="orgstruct-menu">
      <div>
        <add-users-dialog
          v-if="$canAndRulesPass(user, 'user.see_find_button_in_orgstruct')"
          single-select
          title-text="Поиск сотрудника"
          add-button-text="Нажмите на строку для выбора"
          @users-selected="loadInit($event.id)"
        >
          <el-button
            slot="reference"
            type="primary"
            size="mini"
            icon="fas fa-search"
          >
            Найти сотрудника
          </el-button>
        </add-users-dialog>
      </div>
      <div>

        <el-checkbox-group size="small" v-model="toggleShowFunctionalChief" style="display: inline-block; margin-right: 10px">
          <el-checkbox-button>
            <i style="margin-right: 8px" class="fas fa-table"></i>
            <span v-if="toggleShowFunctionalChief">Скрыть ФР</span>
            <span v-else>Открыть ФР</span>
          </el-checkbox-button>
        </el-checkbox-group>
        <el-checkbox-group size="small" v-model="showCards" style="display: inline-block">
          <el-checkbox-button>
            <i style="margin-right: 8px" class="fas fa-table"></i>
            <span v-if="showCards">Скрыть показатели</span>
            <span v-else>Открыть показатели</span>
          </el-checkbox-button>
        </el-checkbox-group>
      </div>
    </div>


  </div>

</template>

<script>

import {mapGetters} from "vuex";
import OrgstructTree from "@/components/orgstruct/OrgstuctTree.vue";
import AddUsersDialog from "@/components/user/AddUsersDialog.vue";

export default {
  name: 'Orgstruct',

  components: {AddUsersDialog, OrgstructTree},

  data() {
    return {
      loading: false,

      ds: {},
      currentUserId: null,

      showCards: true,
      toggleShowFunctionalChief: true,

    }
  },
  computed: {
    ...mapGetters(['user'])
  },
  mounted() {
    this.loadInit();
  },
  methods: {
    loadInit(id) {
      this.loading = true;
      this.$refs.orgstructTree.lastNode = null;
      this.$api.orgstruct.getInit({
        id: id,
        expand: [
          'card_elements.scale', 'chief_functional',
          'meta'
          // 'chief_direct', 'chief_direct.card_elements.scale', 'chief_direct.chief_functional',
          // 'immediate_employees', 'immediate_employees.card_elements.scale', 'immediate_employees.chief_functional',
          // 'chief_functional', 'card_elements.scale',
        ].join(),
      })
        .then(data => {
          this.currentUserId = data.user.id;
          let tree = {};

          if (data.immediate_employees) {
            data.user.subordinates = data.immediate_employees;
            delete data.immediate_employees;
          }

          if (data.chief_direct) {
            tree = data.chief_direct;
            tree.subordinates = [data.user];
          } else {
            tree = data.user;
          }

          this.ds = tree;
        })
        .finally(() => {
          this.loading = false;
        })
    },


    loadParent({datasource:node, e}) {
      this.loading = true;
      this.$api.orgstruct.getParent({
        id: node.id,
        expand: [
          'card_elements.scale', 'chief_functional',
          'meta'
          // 'chief_direct.chief_functional', 'chief_direct.chief_functional.card_elements.scale',
          // 'chief_direct.immediate_employees', 'chief_direct.immediate_employees.card_elements.scale',
        ].join(),
      })
        .then(data => {
          let tree = {};

          if (!data.chief_direct) {
            node.direct_chief_id = null;
            return;
          }

          tree = data.chief_direct;
          tree.subordinates = data.chief_direct_employees;

          tree.subordinates.forEach(sub => {
            if (sub.id == node.id) {
              sub.subordinates = node.subordinates;
            }
          })

          this.ds = tree;
        })
        .finally(() => {
          this.loading = false;
        })
    },


    loadChild({datasource:node, e}) {
      this.loading = true;
      this.$api.orgstruct.getChild({
        id: node.id,
        expand: [
          // 'immediate_employees', 'immediate_employees.card_elements.scale',
          // 'immediate_employees.chief_functional', 'immediate_employees.chief_functional.card_elements.scale',
          'chief_functional', 'card_elements.scale',
          'meta'
        ].join(),
      })
        .then(data => {
          this.$set(node, 'subordinates', data.immediate_employees);
        })
        .finally(() => {
          this.loading = false;
        })
    },


  }
}

</script>

<style>
.orgchart-container {
  height: 89vh;
}

.orgstruct-menu {
  width: 93vw;
  position: absolute;
  top: 20px;
  left: 20px;
  display: flex;
  justify-content: space-between;
}
</style>